import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ClientsContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }


    render()
    { 

      const clients = this.props.type == "clients" ? this.props.clients : JSON.parse(localStorage.getItem("partners")); 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (

      <section className="people-block section-padded">
      <div className="content">
       
          {this.props.type == "clients" && 
           <blockquote>
          Our clients are our Partners too. Together, we ignite innovation and unlock
          transformative solutions, shaping the future of our industry.
          </blockquote>

    }
    {this.props.type == "partners" && 
     <blockquote>
    Enhancing innovative technical solutions. Fueling relentless innovation and transformative solutions through strategic collaboration.
     </blockquote>
    }
       

        <div className="client-cards">

          {clients.length && clients.map((item, index) => (
            
          <div
            data-aos="fade-up"
            data-aos-duration="500"
            data-aos-delay="0"
            className={"client-card cast"+index+" aos-init aos-animate"}
          >
            <Link target="_blank" to={item.url} className="client-card-content">
              <img src={item.image} alt={item.title} />
            </Link>
          </div>

          ))}
     </div>
<div class="space"></div>
     </div>
     </section>
       

    );
 
    }
}

export default ClientsContent;